export const iphone5s = "374px"
export const phone = "768px"
export const tablet = "992px"
export const ipadProTablet = "1067px"
export const desktop = "1200px"
export const highDpiDesktop = "1750px"
